import React, { useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import useAppContext from 'flow/hooks/useAppContext';
import MeetingButton from 'flow/components/meeting/MeetingButton';
import BackgroundEffectsModal from 'flow/components/meeting/shared/BackgroundEffectsModal';
import { getFooterButtonHiddenClass } from 'flow/utils/meeting-footer-utils';

export const ButtonDisplayBackgroundEffectsModal = () => {
    const { i18next } = useAppContext();
    const anchorRef = useRef<HTMLDivElement>(null);

    const [displayBackgroundEffects, setDisplayBackgroundEffects] =
        useState<boolean>(false);

    return (
        <>
            <div
                ref={anchorRef}
                className={twMerge(
                    'flex flex-col items-center justify-center text-xs select-none',
                    getFooterButtonHiddenClass(),
                )}
                data-test-id={'meeting-background-effects-button'}
            >
                <MeetingButton
                    iconType={'photo_filter'}
                    active={displayBackgroundEffects}
                    subtleActive={true}
                    callback={() =>
                        setDisplayBackgroundEffects((isOpen) => !isOpen)
                    }
                    hoverText={i18next.t(
                        'videoconference.background_effects.title',
                    )}
                />
            </div>
            {displayBackgroundEffects && (
                <BackgroundEffectsModal
                    anchorEl={anchorRef.current}
                    placement="top"
                    onClose={() => setDisplayBackgroundEffects(false)}
                />
            )}
        </>
    );
};

export default ButtonDisplayBackgroundEffectsModal;
